import {Action as BaseAction} from 'small-redux';

/**
 * Объект действия.
 * 
 * @template T Тип возможных действий.
 */
interface Action<T> extends BaseAction
{
	/** Тип */
	type: keyof T;
	/** Данные */
	payload: any;
}

// tslint:disable:no-unnecessary-type-assertion

// tslint:disable-next-line:variable-name
const ActionsCommon = {
	COMMON$_SET_LOADING: 'COMMON$_SET_LOADING' as 'COMMON$_SET_LOADING',
	COMMON$_SET_VISUAL_MODE: 'COMMON$_SET_VISUAL_MODE' as 'COMMON$_SET_VISUAL_MODE',
};

// tslint:disable-next-line:variable-name
const ActionsFilter = {
	FILTER$_SET_FILTER: 'FILTER$_SET_FILTER' as 'FILTER$_SET_FILTER',
	FILTER$_TOGGLE_SECTION: 'FILTER$_TOGGLE_SECTION' as 'FILTER$_TOGGLE_SECTION',
	FILTER$_TOGGLE_ROOM_TYPE: 'FILTER$_TOGGLE_ROOM_TYPE' as 'FILTER$_TOGGLE_ROOM_TYPE',
	FILTER$_SET_FLOOR_FROM: 'FILTER$_SET_FLOOR_FROM' as 'FILTER$_SET_FLOOR_FROM',
	FILTER$_SET_FLOOR_TO: 'FILTER$_SET_FLOOR_TO' as 'FILTER$_SET_FLOOR_TO',
	FILTER$_SET_SQUARE_TOTAL_FROM: 'FILTER$_SET_SQUARE_TOTAL_FROM' as 'FILTER$_SET_SQUARE_TOTAL_FROM',
	FILTER$_SET_SQUARE_TOTAL_TO: 'FILTER$_SET_SQUARE_TOTAL_TO' as 'FILTER$_SET_SQUARE_TOTAL_TO',
	FILTER$_SET_TOTAL_COST_FROM: 'FILTER$_SET_TOTAL_COST_FROM' as 'FILTER$_SET_TOTAL_COST_FROM',
	FILTER$_SET_TOTAL_COST_TO: 'FILTER$_SET_TOTAL_COST_TO' as 'FILTER$_SET_TOTAL_COST_TO',
};

// tslint:disable-next-line:variable-name
const ActionsListData = {
	LIST_DATA$_SET_ITEMS: 'LIST_DATA$_SET_ITEMS' as 'LIST_DATA$_SET_ITEMS',
	LIST_DATA$_APPEND_ITEMS: 'LIST_DATA$_APPEND_ITEMS' as 'LIST_DATA$_APPEND_ITEMS',
	LIST_DATA$_SET_LIST_MODE: 'LIST_DATA$_SET_LIST_MODE' as 'LIST_DATA$_SET_LIST_MODE',
};

// tslint:disable-next-line:variable-name
const ActionsVisualData = {
	VISUAL_DATA$_SET_OVERVIEW: 'VISUAL_DATA$_SET_OVERVIEW' as 'VISUAL_DATA$_SET_OVERVIEW',
	VISUAL_DATA$_SET_BUILDING: 'VISUAL_DATA$_SET_BUILDING' as 'VISUAL_DATA$_SET_BUILDING',
	VISUAL_DATA$_SET_SECTION: 'VISUAL_DATA$_SET_SECTION' as 'VISUAL_DATA$_SET_SECTION',
	VISUAL_DATA$_SET_FLOOR: 'VISUAL_DATA$_SET_FLOOR' as 'VISUAL_DATA$_SET_FLOOR',
	VISUAL_DATA$_SET_STEP: 'VISUAL_DATA$_SET_STEP' as 'VISUAL_DATA$_SET_STEP',
	VISUAL_DATA$_SET_TOOLTIP: 'VISUAL_DATA$_SET_TOOLTIP' as 'VISUAL_DATA$_SET_TOOLTIP',
	VISUAL_DATA$_SET_FILTER_VISIBLE: 'VISUAL_DATA$_SET_FILTER_VISIBLE' as 'VISUAL_DATA$_SET_FILTER_VISIBLE',
};

/**
 * Module.
 */
export {
	Action,
	ActionsCommon,
	ActionsFilter,
	ActionsListData,
	ActionsVisualData,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/Store/Actions.ts